export const SHOPPING_CART_FEATURE_ID = 'shoppingCart';

